export const SEARCH_BASE_URL = "https://m.np.playstation.com/api/search";
